import {
   serverGetRequestByUrl,
   serverPatchRequestByUrlAndDataWithMsg,
   serverPostRequest,
   serverPostRequestByUrlAndDataWithMsg,
   serverPostRequestByUrlAndDataWithMsgForExport,
   serverPostRequestByUrlAndDataWithMsgMultipart,
} from 'app/services/utilsServices';
import promiseFactory from 'util/promiseFactory';

const SA_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_SPONSORED_ADS_SECURE }`;

export const getSiteSelectOptions = promiseFactory.getSuggestionsForSelect(`${ SA_SECURE_BASE_URL }site/get-select`);
// source (used by APP: SSA as well)
export const getOfferSourceSelectOptions = promiseFactory.getSuggestionsForSelect(`${ SA_SECURE_BASE_URL }offer-source/get-select`);
// source (used by APP: SSA as well)
export const getSourceSelectOptions = promiseFactory.getSuggestionsForSelect(`${ SA_SECURE_BASE_URL }sources/get-select`);
// ad-group (used by APP: SSA as well)
export const getAdGroupSelectOptions = promiseFactory.getSuggestionsForSelect(`${ SA_SECURE_BASE_URL }ad-group/get-select`);

// REPORT
const REPORT = `${ SA_SECURE_BASE_URL }report/`;
export const sponsoredAdsReportDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ REPORT }details`, requestData);
};

export const sponsoredAdsReportExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ REPORT }export`, requestData);
};

export const sponsoredAdsGetPixel = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ REPORT }get-pixel`, requestData);
};

export const sponsoredAdsScheduleReport = serverPostRequest(`${ REPORT }schedule-report`);

// PUBLISHER REPORT
const PUBLISHER_REPORT = `${ SA_SECURE_BASE_URL }publisher-report/`;
export const sponsoredAdsPublisherReportDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ PUBLISHER_REPORT }details`, requestData);
};

export const sponsoredAdsPublisherReportExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ PUBLISHER_REPORT }export`, requestData);
};

// EDIT CAMPAIGN
const EDIT_CAMPAIGN = `${ SA_SECURE_BASE_URL }edit-campaign/`;
export const sponsoredAdsEditCampaignDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ EDIT_CAMPAIGN }details`, requestData);
};

export const sponsoredAdsEditCampaignExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ EDIT_CAMPAIGN }export`, requestData);
};

export const sponsoredAdsEditCampaignSave = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ EDIT_CAMPAIGN }save`, requestData);
};

// EDIT ADVERTISER
const EDIT_ADVERTISER = `${ SA_SECURE_BASE_URL }edit-advertiser/`;
export const sponsoredAdsEditAdvertiserDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ EDIT_ADVERTISER }details`, requestData);
};
export const sponsoredAdsEditAdvertiserExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ EDIT_ADVERTISER }export`, requestData);
};
export const sponsoredAdsEditAdvertiserSave = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ EDIT_ADVERTISER }save`, requestData);
};

// CAMPAIGN
const CAMPAIGN_BASE_URL = `${ SA_SECURE_BASE_URL }campaign`;

export const patchCampaign = (campaignId, requestData) => {
   return serverPatchRequestByUrlAndDataWithMsg(`${ CAMPAIGN_BASE_URL }/${ campaignId}`, requestData);
};

// CAMPAIGN MANAGER
const CAMPAIGN_MANAGER = `${ SA_SECURE_BASE_URL }campaign-manager/`;
export const sponsoredAdsCampaignManagerDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }details`, requestData);
};

export const sponsoredAdsCampaignManagerDuplicate = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }duplicate`, requestData);
};

export const sponsoredAdsCampaignManagerExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ CAMPAIGN_MANAGER }export`, requestData);
};

export const sponsoredAdsCampaignManagerSetEditorialStatus = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }set-editorial-status`, requestData);
};

export const sponsoredAdsCampaignManagerDeleteLearningKeywords = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }delete-keywords`, requestData);
};

export const sponsoredAdsCampaignManagerLoadLearningKeywords = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${CAMPAIGN_MANAGER}load-keywords`, requestData);
};

export const sponsoredAdsCampaignManagerEditLearningKeywords = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${CAMPAIGN_MANAGER}edit-keywords`, requestData);
};

export const sponsoredAdsCampaignManagerBulkActions = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }bulk-action`, requestData);
};

export const sponsoredAdsCampaignManagerBulkActionLoad = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }bulk-action/load`, requestData);
};

export const sponsoredAdsCampaignManagerBulkActionEdit = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }bulk-action/edit`, requestData);
};

export const sponsoredAdsCampaignManagerLoadAdvertiserBudget = () => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }load-advertiser-budget`, {});
};

export const sponsoredAdsCampaignManagerEditAdvertiserBudget = (payload) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ CAMPAIGN_MANAGER }edit-advertiser-budget`, payload);
};

export const sponsoredAdsCampaignManagerUploadCampaigns = (payload) => {
   return serverPostRequestByUrlAndDataWithMsgMultipart(`${ CAMPAIGN_MANAGER }upload-campaign`, payload);
};

// campaign Manager Form
export const sponsoredAdsCampaignManagerLoadCampaign = (id) => {
   return promiseFactory.postPayloadWithFormCB(`${CAMPAIGN_MANAGER}load`, { campaignId: id });
};

export const sponsoredAdsCampaignManagerEditCampaign = serverPostRequest(`${ CAMPAIGN_MANAGER }edit`);
export const sponsoredAdsCampaignManagerCreateCampaign = serverPostRequest(`${ CAMPAIGN_MANAGER }add`);

// TRAFFIC QUALITY REPORT
const TRAFFIC_QUALITY_REPORT = `${ SA_SECURE_BASE_URL }traffic-quality-report/`;
export const sponsoredAdsTrafficQualityReportDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ TRAFFIC_QUALITY_REPORT }details`, requestData);
};

export const sponsoredAdsTrafficQualityReportExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ TRAFFIC_QUALITY_REPORT }export`, requestData);
};

// TRAFFIC RULE - ADVERTISER RULE
const TRAFFIC_RULE_ADVERTISER_RULE = `${ SA_SECURE_BASE_URL }traffic-rule/advertiser-rule/`;
export const sponsoredAdsTrafficRuleAdvertiserDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ TRAFFIC_RULE_ADVERTISER_RULE }details`, requestData);
};

export const sponsoredAdsTrafficRuleAdvertiserExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ TRAFFIC_RULE_ADVERTISER_RULE }export`, requestData);
};

// sponsoredAdsAdvertiserCreateEditForm services
export const sponsoredAdsAdvertiserTrafficRuleCreate = serverPostRequest(`${ TRAFFIC_RULE_ADVERTISER_RULE }create`);
export const sponsoredAdsAdvertiserTrafficRuleUpdate = (id) => serverPostRequest(`${ TRAFFIC_RULE_ADVERTISER_RULE }update?id=${ id }`);
export const sponsoredAdsAdvertiserTrafficRuleGet = (id) => serverPostRequest(`${ TRAFFIC_RULE_ADVERTISER_RULE }get?id=${ id }`);

export const sponsoredAdsAdvertiserTrafficRuleDelete = (id) => serverPostRequest(`${ TRAFFIC_RULE_ADVERTISER_RULE }delete?id=${ id }`);

export const sponsoredAdsAdvertiserTrafficRuleToggle = (id) => serverPostRequest(`${ TRAFFIC_RULE_ADVERTISER_RULE }toggle-status?id=${ id }`);
export const sponsoredAdsAdvertiserTrafficRuleClone = (id) => serverPostRequest(`${ TRAFFIC_RULE_ADVERTISER_RULE }clone?id=${ id }`);

// TRAFFIC RULE - PUBLISHER RULE
const TRAFFIC_RULE_PUBLISHER_RULE = `${ SA_SECURE_BASE_URL }traffic-rule/publisher-rule/`;
export const sponsoredAdsTrafficRulePublisherDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ TRAFFIC_RULE_PUBLISHER_RULE }details`, requestData);
};

export const sponsoredAdsTrafficRulePublisherExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ TRAFFIC_RULE_PUBLISHER_RULE }export`, requestData);
};

// sponsoredAdsPublisherCreateEditForm services
export const sponsoredAdsPublisherTrafficRuleCreate = serverPostRequest(`${ TRAFFIC_RULE_PUBLISHER_RULE }create`);
export const sponsoredAdsPublisherTrafficRuleUpdate = (id) => serverPostRequest(`${ TRAFFIC_RULE_PUBLISHER_RULE }update?id=${ id }`);
export const sponsoredAdsPublisherTrafficRuleGet = (id) => serverPostRequest(`${ TRAFFIC_RULE_PUBLISHER_RULE }get?id=${ id }`);
export const sponsoredAdsPublisherTrafficRuleDelete = (id) => serverPostRequest(`${ TRAFFIC_RULE_PUBLISHER_RULE }delete?id=${ id }`);
export const sponsoredAdsPublisherTrafficRuleToggle = (id) => serverPostRequest(`${ TRAFFIC_RULE_PUBLISHER_RULE }toggle-status?id=${ id }`);
export const sponsoredAdsPublisherTrafficRuleClone = (id) => serverPostRequest(`${ TRAFFIC_RULE_PUBLISHER_RULE }clone?id=${ id }`);

// ADS KEYWORD SEARCH
// https://l5srv.net/AdServer/get.ads?run=yes&GID=1&d=0&t=&cl=&l=&cs=1&rb=1&s=%2F%2Fl5srv.net%2FAdServer%2Fget.ads&export=html&format=json
// https://lfprod.upward.net/AdServer/get.ads?run=yes&GID=1&d=0&t=&cl=&l=&cs=1&rb=1&s=%2F%2Fl5srv.net%2FAdServer%2Fget.ads&export=html&format=json
// const ADS_KEYWORD_SEARCH = `${ SA_SECURE_BASE_URL }edit-campaign/`;

export const sponsoredAdsKeywordSearchToolDetails = (requestData) => {
   const internalOrSyndicationParam = (value) => {
      if (value === 'SYNDICATION') {
         return '%2F%2Fl5srv.net%2FAdServer%2FsynGet.ads';
      }

      return '%2F%2Fl5srv.net%2FAdServer%2Fget.ads';
   };
   const { CPCScale, adGroup, cloud, device, location, relevanceBottom, search, showDisplayUrl,
      showLineOne, showLinkUrl, showRelevance, term } = requestData;
   const queryArray = [];
   queryArray.push('run=yes');
   queryArray.push(`GID=${ adGroup?.id ? adGroup?.id : '' }`);
   queryArray.push(`d=${ device?.id }`);
   queryArray.push(`t=${ term || '' }`);
   queryArray.push(`cl=${ cloud || '' }`);
   queryArray.push(`l=${ location || '' }`);
   queryArray.push(`cs=${ CPCScale || '' }`);
   queryArray.push(`rb=${ relevanceBottom || '' }`);
   queryArray.push(`s=${ internalOrSyndicationParam(search?.value) }`);
   if (showDisplayUrl) {
      queryArray.push('show_dispurl=Y');
   }
   if (showLineOne) {
      queryArray.push('show_line1=Y');
   }
   if (showLinkUrl) {
      queryArray.push('show_linkurl=Y');
   }
   if (showRelevance) {
      queryArray.push('show_relevance');
   }
   queryArray.push('export=html');
   queryArray.push('format=json');

   return serverGetRequestByUrl(`https://ad-service.sensitive-marketplace-production.ojop.io/ad-service/get.ads?pos=1&${ queryArray.join('&') }`, 'KEYWORD_SEARCH');
};

const ADS_BILLING_SUMMARY = `${ process.env.REACT_APP_MS_BILLING_ADS_SECURE }billing-summary`;
export const sponsoredAdsBillingSummaryDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ ADS_BILLING_SUMMARY }/details`, requestData);
};

export const sponsoredAdsBillingSummaryExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ ADS_BILLING_SUMMARY }/export`, requestData);
};

const ADVERTISER_LOGOS = `${ SA_SECURE_BASE_URL }company-logos/`;
export const sponsoredAdLogosDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ ADVERTISER_LOGOS }details`, requestData);
};

export const sponsoredAdLogosDelete = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ ADVERTISER_LOGOS }delete`, requestData);
};

export const sponsoredAdLogosUpload = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgMultipart(`${ ADVERTISER_LOGOS }upload`, requestData);
};

export const sponsoredAdLogosDownload = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ ADVERTISER_LOGOS }download?logoDomain=${ requestData.logoDomain }&domain=${ requestData.domain }`, requestData);
};

// SA KEYWORDS FETCH

export const sponsoredAdKeywordsGetAll = serverPostRequest(`${ SA_SECURE_BASE_URL }keyword/getAll`);
